module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-ExtraBold.5d3dd852.ttf";